if (typeof NewsletterConsent !== 'function') {
  class NewsletterConsent extends HTMLElement {
    constructor() {
      super();

      this.form = this.closest('form');
      this.checkbox = this.querySelector('.consent-validation__checkbox');
      this.error = this.querySelector('[data-newsletter-consent-error]');
      this.errorMessage = this.dataset.errorMessage || '';

      if (!this.form || !this.checkbox || !this.error) {
        return;
      }

      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleChange = this.handleChange.bind(this);

      this.form.addEventListener('submit', this.handleSubmit);
      this.checkbox.addEventListener('change', this.handleChange);
    }

    handleSubmit(event) {
      if (this.checkbox.checked) {
        this.toggleError(false);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this.toggleError(true);

      this.checkbox.focus({ preventScroll: true });
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    handleChange() {
      if (this.checkbox.checked) {
        this.toggleError(false);
      }
    }

    toggleError(isVisible) {
      this.classList.toggle('is-invalid', isVisible);
      this.checkbox.setAttribute('aria-invalid', isVisible ? 'true' : 'false');
      this.error.hidden = !isVisible;
      this.error.textContent = isVisible ? this.errorMessage : '';
    }
  }

  if (typeof customElements.get('newsletter-consent') === 'undefined') {
    customElements.define('newsletter-consent', NewsletterConsent);
  }
}
